import {Item} from "../../models/Item";
import {AbstractMainPlugin} from "../AbstractMainPlugin";
import {CesiumAdapterService} from "../../services/cesiumAdapter21/cesium-adapter.service";
import {AppInjector, appInjector} from "../appInjector";
import {combineAll, debounceTime, mergeMap, skipUntil} from "rxjs/operators";
import {combineLatest, Observable} from "rxjs";
import {ObjectConfig} from "../../models/ObjectConfig";
import {UiAdapterService} from "../../services/uiAdapterService/ui-adapter.service";
import {RotateObjectService} from "../../services/rotateService/rotate-object.service";

var _metersPerPx;
export class DynamicIconPlugin extends AbstractMainPlugin{

  private cesiumAdapter: CesiumAdapterService;
  private uiAdapter: UiAdapterService;
  private rotateService: RotateObjectService;
  private dynamicIconUrl: string;
  private isSelected = false;
  private currentDiv:HTMLElement;
  private isLoaded = new Observable((observer)=>{
    observer.next(true);
    observer.complete();
  });
  private additionalRotateBySceneRotation: number = 0;

  constructor(item:Item) {
    super(item);

    if (window['BILLBOARD_DYNAMIC_FIGURES_ALLOWED']) {
      // todo: need to fix fixedHeight, _adjust_width (fixedWidth ?) in inputs
      if (this.item.config.getTool().url_for_dynamic_icon
        && this.item.config.getInputProp('fixedHeight', 'value') == 1.185
        && this.item.config.getInputProp('_adjust_width', 'calculation')
        && (this.item.config.getInputProp('_adjust_width', 'calculation').indexOf('2.35 *') != -1
          || this.item.config.getInputProp('_adjust_width', 'calculation').indexOf('2.35*') != -1
        )
      ) {
        this.item.config.setInputValue('fixedHeight', 'value', 2.35 / 1.5);
      }
    }

    this.initListeners();
  }

  private initListeners(){
    if (this.item.config.getTool().url_for_dynamic_icon) {
      this.cesiumAdapter = appInjector.get(CesiumAdapterService);
      this.uiAdapter = appInjector.get(UiAdapterService);
      this.rotateService = appInjector.get(RotateObjectService);
      this.dynamicIconUrl = this.item.config.getTool().url_for_dynamic_icon;

      if (!window['BILLBOARD_DYNAMIC_FIGURES_ALLOWED']) {
        this.item.getSubject(Item.MODEL_TRANSPARENCY).next(true);
      }
      this.redrawObject();


      this.item.config.subject.subscribe((config) => {
        this.redrawObject();
      });

      this.item.config.serverUpdate.subscribe((config) => {
        this.redrawObject();
      });

      this.cesiumAdapter.tilesLoaded.subscribe((status)=>{
        if (status){
          this.isLoaded.subscribe();
        }
      });

      this.item.getSubject('overlayDrawn').subscribe(()=>{
        this.currentDiv = document.querySelector('#map-text-label-id-'+this.item.getId());
        this.rotateLabel();
      });

      combineLatest(this.cesiumAdapter.cameraEventMoveEnd, this.cesiumAdapter.tilesLoaded).pipe(debounceTime(500)).subscribe(([zoom, status])=>{
        if (status){
          this.item.getObservable('executeModelResize').next(this.getPreparedOptions());
        }
      });

      this.uiAdapter.selectedItem$.subscribe((item)=>{
        this.isSelected = item instanceof Item && item.getId() == this.item.getId();
        if (!(item instanceof Item) ){
          this.isSelected = false;
        }
      });

      this.rotateService.objectRotated$.subscribe((rotateDegrees)=>{
        if (this.isSelected){
          this.rotateLabel(rotateDegrees);
        }
      });

      this.cesiumAdapter.onOverlayChangePosition.subscribe((config)=>{
        if (this.isSelected && config.id == 'map-text-label-id-'+this.item.getId()){
          this.item.config.getObjectConfig().setPosition(config.position);
        }
      })

      this.cesiumAdapter.sceneRotated$.subscribe((degrees)=>{
        this.additionalRotateBySceneRotation = -1*degrees;
        this.rotateLabel();
      })
      this.cesiumAdapter.hideOverlaysObject$.subscribe((flag)=>{
        this.item.getSubject(Item.SUBJECT_VISIBILITY).next(!flag);
      })
    }
  }

  private rotateLabel(rotation?){
    if (window['BILLBOARD_DYNAMIC_FIGURES_ALLOWED']) {
      return;
    }

    console.log('rotateLabel', this.item.config.getRotation(), this.additionalRotateBySceneRotation);
    if (!rotation && rotation != 0){
      rotation = this.item.config.getRotation()+this.additionalRotateBySceneRotation;
      const cssConfig = this.item.config.getInputProp('__url_for_dynamic_icon', 'mapLabelCSSStyle');
      cssConfig.transform = 'translate(-50%, -50%) rotate(' + rotation + 'deg)';
      this.item.config.setInputValue('__url_for_dynamic_icon', 'mapLabelCSSStyle', cssConfig);
    } else {
      if (this.currentDiv){
        this.currentDiv.style.transform = 'translate(-50%, -50%) rotate('+rotation+this.additionalRotateBySceneRotation+'deg)';
      }
    }
  }

  private getPreparedOptions(){
    return {
      spacing: this.item.config.getInputProp('vertical_gap', 'value'),
      rows: this.item.config.getInputProp('rows', 'value'),
      seat_depth: this.item.config.getInputProp('seat_depth', 'value'),
    }
  }

  private redrawObject(){
    try {
      //todo: fix fixedWidth  in inputs
      //manual calculated value
      _metersPerPx = 0.11664899257342563;
      let fixedWidthBeforeCalc = this.item.config.getObjectConfig().getFixedWidth();
      if (this.item.config.getInputProp('_adjust_width', 'calculation')){
        var c = new Function(
          'item',
          this.item.config.getInputProp('_adjust_width', 'calculation')
            .replace(/.inputs/gm, '.config.getInputs()')
            .replace(/item.objects\[0].fixed_width = width;/gm, 'item.config.getObjectConfig().setData(\'fixed_width\', width);')
        );
      }

      c(this.item);

      let fixedWidthAfterCalc = this.item.config.getObjectConfig().getFixedWidth();

      if (fixedWidthBeforeCalc!==fixedWidthAfterCalc){
        this.item.config.getObjectConfig().setData('fixed_width', fixedWidthAfterCalc);
        let inputs = this.item.config.getInputs();
        if (inputs.hasOwnProperty('fixedWidth')) {
          this.item.config.setInputValue('fixedWidth', 'value', fixedWidthAfterCalc, true);
        }
      }

      let additionalStr = '?id='+window['EVENT_ID'];
      for (var i in this.item.config.getInputs()) {
        if (!i || i.substring(0, 2) === '__' || i === 'w3w'){
            continue;
        }
        additionalStr+= '&'+encodeURIComponent(i) + '=' + encodeURIComponent(this.item.config.getInputProp(i, 'value'));
      }

      var result = this.dynamicIconUrl+additionalStr;

      let image = "<img src='"+result+"' alt=''>";

      let input = {"__url_for_dynamic_icon": {"showOnMap": true, "labelImage": image, anchor: "CENTER", "widthInMeters": this.item.config.getObjectConfig().getFixedWidth(), "__isObject":{value: true}, "mapLabelCSSStyle": { "widthInMeters": this.item.config.getObjectConfig().getFixedWidth()}}};

      if (!this.item.config.getInputByName('__url_for_dynamic_icon')){
        this.item.config.assignInputs(input);
      }
      else{
        let cssConfig = this.item.config.getInputProp('__url_for_dynamic_icon', 'mapLabelCSSStyle');
        cssConfig.widthInMeters = this.item.config.getObjectConfig().getFixedWidth();
        this.item.config.setInputValue('__url_for_dynamic_icon', 'labelImage', image);
        this.item.config.setInputValue('__url_for_dynamic_icon', 'widthInMeters', this.item.config.getObjectConfig().getFixedWidth());
        this.item.config.setInputValue('__url_for_dynamic_icon', 'mapLabelCSSStyle', cssConfig);
        this.item.config.setInputValue('__url_for_dynamic_icon', '__isObject', {value: true});

        if (window['BILLBOARD_DYNAMIC_FIGURES_ALLOWED']) {
          this.item.config.setInputValue('__url_for_dynamic_icon', 'mapLabelPosition', this.item.config.getObjectConfig().getPosition());
        }
      }

      if (this.item.config.getObjectConfig().getMapIcon() != result) {
        let defaultImage = this.dynamicIconUrl+'?id='+window['EVENT_ID'];
        this.item.config.getObjectConfig().setMapIcon(result);
      }

      if (!window['BILLBOARD_DYNAMIC_FIGURES_ALLOWED']) {
        this.item.getSubject(Item.MODEL_TRANSPARENCY).next(true);
      }

      this.rotateLabel();

    } catch (e) {
      console.error("Can't execute dynamic image icon", e);
    }
  }
}

